import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import '../styles.css';

const MOIS = ['Jan','Fév','Mar','Avr','Mai','Jun','Jul','Aoû','Sep','Oct','Nov','Déc'];
const JOURS = ['L','M','M','J','V','S','D'];

export default function AgendaPage() {
  const { api, currentGroupeId } = useAuth();
  const [reunions, setReunions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState('liste');
  const [openId, setOpenId] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(new Date());

  useEffect(() => {
    if (!currentGroupeId) { setLoading(false); return; }
    api.get(`/reunions?groupe_id=${currentGroupeId}&upcoming=true`)
      .then(r => setReunions(r.data))
      .catch(() => setReunions([]))
      .finally(() => setLoading(false));
  }, [currentGroupeId, api]);

  // Données de démo si pas encore d'API
  const demoReunions = [
    { id: '1', date_reunion: '2026-03-20T08:30:00', type: 'reunion', titre: 'Réunion mensuelle', lieu: 'Salle Étoile — 12 rue du Commerce, Lille', theme_formation: 'La prospection digitale', mini_conference: 'Thomas Moreau', nb_confirmes: 28, nb_total: 38 },
    { id: '2', date_reunion: '2026-03-27T12:00:00', type: 'evenement', titre: 'Atelier networking', lieu: 'En ligne (visioconférence)', nb_confirmes: 18, nb_total: 38 },
    { id: '3', date_reunion: '2026-04-03T08:30:00', type: 'reunion', titre: 'Réunion mensuelle', lieu: 'Salle Étoile — 12 rue du Commerce, Lille', nb_confirmes: 0, nb_total: 38 },
    { id: '4', date_reunion: '2026-04-18T19:00:00', type: 'after_work', titre: 'Gala annuel du réseau', lieu: 'Grand Hôtel Bellevue — Grand\'Place, Lille', nb_confirmes: 35, nb_total: 38 },
  ];

  const data = reunions.length > 0 ? reunions : demoReunions;

  const grouped = data.reduce((acc, r) => {
    const d = new Date(r.date_reunion);
    const key = `${d.getFullYear()}-${d.getMonth()}`;
    const label = d.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
    if (!acc[key]) acc[key] = { label, items: [] };
    acc[key].items.push(r);
    return acc;
  }, {});

  const typeColor = (t) => ({
    reunion: { bg: '#f0f8e1', color: '#3B6D11', label: 'Réunion' },
    evenement: { bg: '#f5ede8', color: '#3C2618', label: 'Événement' },
    after_work: { bg: '#fff3e0', color: '#b45309', label: 'After-work' },
  }[t] || { bg: '#f2f2f7', color: '#8e8e93', label: t });

  const typeAccent = (t) => ({ reunion: '#95C11F', evenement: '#3C2618', after_work: '#f59e0b' }[t] || '#95C11F');

  // Calendrier
  const getDaysInMonth = (date) => {
    const year = date.getFullYear(), month = date.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const offset = (firstDay + 6) % 7;
    const prevDays = new Date(year, month, 0).getDate();
    const cells = [];
    for (let i = offset - 1; i >= 0; i--) cells.push({ day: prevDays - i, current: false });
    for (let i = 1; i <= daysInMonth; i++) cells.push({ day: i, current: true });
    while (cells.length % 7 !== 0) cells.push({ day: cells.length - daysInMonth - offset + 1, current: false });
    return cells;
  };

  const eventDays = new Set(data.map(r => new Date(r.date_reunion).getDate()));
  const today = new Date();
  const cells = getDaysInMonth(currentMonth);

  return (
    <div style={{ minHeight: '100vh' }}>
      <div style={{ padding: '12px 20px 10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: '#1c1c1e' }}>Agenda</h1>
        <div style={{ display: 'flex', gap: 6 }}>
          <button onClick={() => setView('liste')}
            style={{ width: 34, height: 34, borderRadius: 10, border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', background: view === 'liste' ? '#95C11F' : 'white', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={view === 'liste' ? 'white' : '#8e8e93'} strokeWidth="2.5"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>
          </button>
          <button onClick={() => setView('cal')}
            style={{ width: 34, height: 34, borderRadius: 10, border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', background: view === 'cal' ? '#95C11F' : 'white', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={view === 'cal' ? 'white' : '#8e8e93'} strokeWidth="2.5"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
          </button>
        </div>
      </div>

      <div className="mb-content" style={{ paddingTop: 0 }}>
        {view === 'liste' ? (
          loading ? <div className="mb-loading"><div className="mb-spinner" /></div> :
          Object.keys(grouped).map(key => (
            <div key={key}>
              <div className="mb-section-label" style={{ textTransform: 'capitalize' }}>{grouped[key].label}</div>
              {grouped[key].items.map(r => {
                const d = new Date(r.date_reunion);
                const tc = typeColor(r.type);
                const isOpen = openId === r.id;
                const pct = r.nb_total > 0 ? Math.round(r.nb_confirmes * 100 / r.nb_total) : 0;
                return (
                  <div key={r.id} className="mb-event-item" style={{ marginBottom: 8 }}>
                    <div className="mb-event-header" onClick={() => setOpenId(isOpen ? null : r.id)}>
                      <div className="mb-event-date" style={{ background: tc.bg }}>
                        <span style={{ fontSize: 19, fontWeight: 700, color: tc.color, lineHeight: 1 }}>{d.getDate()}</span>
                        <span style={{ fontSize: 10, fontWeight: 600, color: tc.color, textTransform: 'uppercase' }}>{MOIS[d.getMonth()]}</span>
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 14, fontWeight: 600, color: '#1c1c1e' }}>{r.titre}</div>
                        <div style={{ fontSize: 12, color: '#8e8e93', marginTop: 2 }}>
                          {d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })} · {r.lieu?.split('—')[0]?.trim() || r.lieu}
                        </div>
                        <span className={`mb-badge mb-badge-${tc.color === '#3B6D11' ? 'green' : tc.color === '#b45309' ? 'orange' : 'brown'}`} style={{ marginTop: 4, background: tc.bg, color: tc.color }}>
                          {tc.label}
                        </span>
                      </div>
                      <svg style={{ transition: 'transform 0.25s', transform: isOpen ? 'rotate(180deg)' : 'none', flexShrink: 0 }} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#c7c7cc" strokeWidth="2.5"><path d="M6 9l6 6 6-6"/></svg>
                    </div>
                    {isOpen && (
                      <div className="mb-event-body">
                        {[
                          { label: 'Horaires', value: `${d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' })} · ${d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}` },
                          r.lieu && { label: 'Lieu', value: r.lieu },
                          r.theme_formation && { label: 'Formation', value: r.theme_formation },
                          r.mini_conference && { label: 'Mini-conf.', value: r.mini_conference },
                        ].filter(Boolean).map(info => (
                          <div key={info.label} className="mb-info-row">
                            <div className="mb-info-ico"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#95C11F" strokeWidth="2"><circle cx="12" cy="12" r="10"/></svg></div>
                            <span className="mb-info-label" style={{ fontSize: 11 }}>{info.label}</span>
                            <span className="mb-info-value" style={{ fontSize: 12 }}>{info.value}</span>
                          </div>
                        ))}
                        {r.nb_total > 0 && (
                          <div style={{ marginTop: 10 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#8e8e93', marginBottom: 4 }}>
                              <span>Confirmés : {r.nb_confirmes}/{r.nb_total}</span>
                              <span style={{ color: '#95C11F', fontWeight: 600 }}>{pct}%</span>
                            </div>
                            <div className="mb-presence-bar"><div className="mb-presence-fill" style={{ width: `${pct}%`, background: pct < 50 ? '#f59e0b' : '#95C11F' }} /></div>
                          </div>
                        )}
                        <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                          <button className="mb-btn mb-btn-ghost mb-btn-sm" style={{ flex: 1, justifyContent: 'center' }}>Je serai présent</button>
                          <button className="mb-btn mb-btn-ghost-brown mb-btn-sm" style={{ flex: 1, justifyContent: 'center' }}>Excusé</button>
                          {r.lieu && <button className="mb-btn mb-btn-sm" style={{ background: '#f2f2f7', color: '#3c3c43' }}>Itinéraire</button>}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ))
        ) : (
          <div className="mb-card">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
              <button onClick={() => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth()-1, 1))}
                style={{ width: 28, height: 28, borderRadius: '50%', background: '#f2f2f7', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#1c1c1e" strokeWidth="2.5"><path d="M15 18l-6-6 6-6"/></svg>
              </button>
              <span style={{ fontSize: 16, fontWeight: 700, color: '#1c1c1e', textTransform: 'capitalize' }}>
                {currentMonth.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })}
              </span>
              <button onClick={() => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth()+1, 1))}
                style={{ width: 28, height: 28, borderRadius: '50%', background: '#f2f2f7', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#1c1c1e" strokeWidth="2.5"><path d="M9 18l6-6-6-6"/></svg>
              </button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', marginBottom: 6 }}>
              {JOURS.map((j, i) => <div key={i} style={{ textAlign: 'center', fontSize: 11, fontWeight: 600, color: '#8e8e93', padding: '4px 0' }}>{j}</div>)}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: 2 }}>
              {cells.map((c, i) => {
                const isToday = c.current && c.day === today.getDate() && currentMonth.getMonth() === today.getMonth() && currentMonth.getFullYear() === today.getFullYear();
                const hasEvent = c.current && eventDays.has(c.day);
                return (
                  <div key={i} style={{ height: 36, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderRadius: 8, background: isToday ? '#95C11F' : 'transparent', cursor: c.current ? 'pointer' : 'default' }}>
                    <span style={{ fontSize: 13, color: isToday ? 'white' : c.current ? '#1c1c1e' : '#c7c7cc', fontWeight: isToday ? 700 : 400 }}>{c.day}</span>
                    {hasEvent && !isToday && <div style={{ width: 4, height: 4, borderRadius: '50%', background: '#95C11F', marginTop: 1 }} />}
                    {hasEvent && isToday && <div style={{ width: 4, height: 4, borderRadius: '50%', background: 'white', marginTop: 1 }} />}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
